<template>
  <div class="file-context">
    <div v-if="pdfUrl" :key="pdfUrl" class="file-box">
      <PdfSingleViewer
        :zoomValue="zoomValue"
        :client="true"
        @changeZoomValue="handleChangeZoomValue"
        :zoom="true"
        :zoomMax="5"
        :shown="true"
        :pdflibSrc="pdflibSrc"
        :pdfWorkerSrc="pdfWorkerSrc"
        :cmapUrl="cmapUrl"
        :pdfUrl="pdfUrl"
        :withCredentials="false"
        :ref="`pdfSingleViewer${id}`"
      ></PdfSingleViewer>
    </div>

    <div class="footer" @click="goback">
      <div>{{ $t('确定') }}</div>
    </div>
  </div>
</template>
<script>
import { PdfSingleViewer } from '@tsign/tsign-ui'

export default {
  components: {
    PdfSingleViewer,
  },
  data() {
    return {
      id: 1,
      pdfUrl: this.$route.query.pdfUrl,
      zoomValue: 1,
      pdflibSrc: '//asset.tsign.cn/apps/tsign-openservice-h5_3.0/common/pdf2.0.489/pdf.min.js',
      pdfWorkerSrc: '//asset.tsign.cn/apps/tsign-openservice-h5_3.0/common/pdf2.0.489/pdf.worker.min.js',
      cmapUrl: '//asset.tsign.cn/apps/tsign-openservice-h5_3.0/common/pdf2.0.489/cmaps/',
    }
  },
  methods: {
    goback() {
      this.$router.go(-1)
    },
    handleChangeZoomValue(zv) {
      this.zoomValue = zv
    },
  },
}
</script>
<style lang="less" scoped>
.footer {
  position: fixed;
  bottom: 0;
  padding: 20px;
  width: 100%;
  background: #fff;
  > div {
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background: linear-gradient(226deg, rgba(230, 77, 46, 1) 0%, rgba(230, 0, 0, 1) 100%);
  }
}
.file-box {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.file-context {
  position: fixed;
  width: 100%;
  top: 44px;
  bottom: 0;
  display: flex;
  flex-direction: column;
}
</style>
